import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
  BaseListenable1u3g4s45l82o6 as BaseListenable,
} from '../core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../core/signals.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Reactive1jy75v4li6ldv as Reactive,
} from '../core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  ReactiveStatel8ixobo86msn as ReactiveState,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
} from '../core/ReactiveState.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lensByElementAssumingSetNeverManipulates(_this__u8e3s4) {
  return lensByElementAssumingSetNeverManipulates_0(_this__u8e3s4, lensByElementAssumingSetNeverManipulates$lambda);
}
function lensByElementAssumingSetNeverManipulates_0(_this__u8e3s4, map) {
  return LensByElementAssumingSetNeverManipulates().gas(_this__u8e3s4, map);
}
function *_generator_set__cb7isu($this, value, $completion) {
  $this.oam(value);
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.las_1.bas_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.f2();
    destination.v(tmp$ret$0);
  }
  var tmp = $this.las_1.zar_1.iah(destination, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var InstanceClass;
function Instance() {
  if (InstanceClass === VOID) {
    class $ extends BaseReactiveValue() {
      static mas($outer, calculationContext, index, value, $box) {
        if ($box === VOID)
          $box = {};
        $box.las_1 = $outer;
        var $this = this.xao(value, $box);
        $this.jas_1 = $this.las_1.aas_1(calculationContext, $this);
        $this.kas_1 = new (Constant())(_Constant___init__impl__v45mub(index));
        return $this;
      }
      nas() {
        return this.kas_1;
      }
      oas(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      iah(value, $completion) {
        return this.oas((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
    }
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    initMetadataForClass($, 'Instance', VOID, VOID, [MutableReactive(), ReactiveValue(), BaseReactiveValue()], [1]);
    InstanceClass = $;
  }
  return InstanceClass;
}
var LensByElementAssumingSetNeverManipulatesClass;
function LensByElementAssumingSetNeverManipulates() {
  if (LensByElementAssumingSetNeverManipulatesClass === VOID) {
    class $ extends BaseListenable() {
      static gas(source, map) {
        var $this = this.uam();
        $this.zar_1 = source;
        $this.aas_1 = map;
        $this.bas_1 = ArrayList().w();
        $this.cas_1 = Companion_getInstance().oah_1;
        $this.das_1 = null;
        $this.eas_1 = false;
        $this.fas_1 = null;
        return $this;
      }
      kal() {
        super.kal();
        var tmp = this;
        tmp.das_1 = this.zar_1.vah(() => {
          this.pas();
          this.mal();
          return Unit_instance;
        });
        this.pas();
      }
      lal() {
        super.lal();
        var tmp0_safe_receiver = this.das_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.das_1 = null;
      }
      qas() {
        if (this.das_1 == null) {
          this.pas();
        }
        return this.cas_1;
      }
      sah() {
        return this.qas();
      }
      pas() {
        if (this.eas_1)
          return Unit_instance;
        var tmp0_safe_receiver = this.fas_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          cancel(tmp0_safe_receiver);
        }
        var context = CoroutineScope(Job());
        this.fas_1 = context;
        var tmp = this;
        var tmp0 = this.zar_1.sah();
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
          var tmp_0;
          var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_1 instanceof InternalReactiveNotReady()) {
            tmp_0 = true;
          } else {
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_0 = tmp_2 instanceof InternalReactiveThrownException();
          }
          if (tmp_0) {
            tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
            break $l$block_1;
          }
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_3 instanceof InternalReactiveWrapper())
            try {
              var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0).tah_1;
              var it = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
              this.bas_1.v3();
              // Inline function 'kotlin.collections.mapIndexed' call
              // Inline function 'kotlin.collections.mapIndexedTo' call
              var destination = ArrayList().u(collectionSizeOrDefault(it, 10));
              var index = 0;
              var _iterator__ex2g4s = it.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                var _unary__edvuaz = index;
                index = _unary__edvuaz + 1 | 0;
                var index_0 = checkIndexOverflow(_unary__edvuaz);
                var tmp$ret$1 = Instance().mas(this, context, index_0, item);
                destination.v(tmp$ret$1);
              }
              this.bas_1.r1(destination);
              // Inline function 'kotlin.collections.map' call
              var this_0 = this.bas_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination_0 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s_0 = this_0.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var item_0 = _iterator__ex2g4s_0.o1();
                var tmp$ret$4 = item_0.jas_1;
                destination_0.v(tmp$ret$4);
              }
              tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(destination_0);
              break $l$block_1;
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp$ret$0 = Companion_getInstance().wah(e);
                break $l$block_1;
              } else {
                throw $p;
              }
            }
          var tmp_5;
          try {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            this.bas_1.v3();
            // Inline function 'kotlin.collections.mapIndexed' call
            // Inline function 'kotlin.collections.mapIndexedTo' call
            var destination_1 = ArrayList().u(collectionSizeOrDefault(it_0, 10));
            var index_1 = 0;
            var _iterator__ex2g4s_1 = it_0.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var item_1 = _iterator__ex2g4s_1.o1();
              var _unary__edvuaz_0 = index_1;
              index_1 = _unary__edvuaz_0 + 1 | 0;
              var index_2 = checkIndexOverflow(_unary__edvuaz_0);
              var tmp$ret$8 = Instance().mas(this, context, index_2, item_1);
              destination_1.v(tmp$ret$8);
            }
            this.bas_1.r1(destination_1);
            // Inline function 'kotlin.collections.map' call
            var this_1 = this.bas_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination_2 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_2 = this_1.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var item_2 = _iterator__ex2g4s_2.o1();
              var tmp$ret$11 = item_2.jas_1;
              destination_2.v(tmp$ret$11);
            }
            tmp_5 = _ReactiveState___init__impl__fvdp9b(destination_2);
          } catch ($p) {
            var tmp_6;
            if ($p instanceof Exception()) {
              var e_0 = $p;
              tmp_6 = Companion_getInstance().wah(e_0);
            } else {
              throw $p;
            }
            tmp_5 = tmp_6;
          }
          tmp$ret$0 = tmp_5;
        }
        tmp.cas_1 = tmp$ret$0;
      }
    }
    initMetadataForClass($, 'LensByElementAssumingSetNeverManipulates', VOID, VOID, [Reactive(), BaseListenable()]);
    LensByElementAssumingSetNeverManipulatesClass = $;
  }
  return LensByElementAssumingSetNeverManipulatesClass;
}
function lensByElementAssumingSetNeverManipulates$lambda($this$lensByElementAssumingSetNeverManipulates, it) {
  return it;
}
//region block: exports
export {
  lensByElementAssumingSetNeverManipulates as lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa,
};
//endregion

//# sourceMappingURL=LensByElementAssumingSetNeverManipulates.mjs.map
